import { IUserVehicleBag } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useUserVehicles = (userId: number | undefined): IUserVehicleBag => {
  const { vehicleStore } = useStore();
  const { userVehicles } = vehicleStore;

  useEffect(() => {
    userId && vehicleStore.getUserVehicles({ userId, maxResultCount: 100, skipCount: 0 });

    return () => {
      vehicleStore.clearUserVehicles();
    };
  }, [vehicleStore, userId]);

  return {
    userVehicles: userVehicles.items,
    totalCount: userVehicles.totalCount,
  };
};
